import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTE_PATHS } from '@/config/app.config'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { LoginShell } from '@/features/auth'

/**
 * `/login` layout — the split-screen shell shared by every sign-in step. Each
 * step (`/login`, `/login/verify-email`, `/login/setup-authenticator`,
 * `/login/setup-authenticator/manual-key`, `/login/verify-app`) renders into its
 * `<Outlet />`. Already-authenticated visitors are bounced home.
 *
 * The Invited User Terms (AMLIQ-101) are no longer gated here: acceptance is
 * tracked server-side per invitee, so an invited user reaches that screen via
 * the tokenized invite link (`/invite-terms?token=…`), not a browser-local flag.
 */
export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: ROUTE_PATHS.root })
    }
  },
  component: LoginLayout,
})

function LoginLayout() {
  return (
    <LoginShell>
      <Outlet />
    </LoginShell>
  )
}
